<template>
	<div class="layout">
		<div id="print-content">
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	export default {
		name: 'documentshare',
		data() {
			return {
				printConfig: {
					receiptTitle: ''
				},
				printData: []
			}
		},
		created() {},
		watch: {
			printConfig: {
				deep: true,
				handler(param) {
					if (param) {
						this.initPrintContext(this.printData.receipts);
						localStorage.setItem('_printConfig' + this.printData.name, JSON.stringify(this.printConfig));
					}
				}
			},
			'$route': {
				immediate: true,
				handler(param) {
					if (param.query.id && param.query.type && param.query.param1 && param.query.param2) {
						this.initData(param.query.id, param.query.type, param.query.param1, param.query.param2);
					}
				}
			}
		},
		methods: {
			initData(id, type, schame, workshop) {
				localStorage.setItem('schema', schame);
				localStorage.setItem('workshop', workshop);
				if (type == '付款单') {
					var self = this;
					request.post('/api/PaymentList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取付款单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packPaymentListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取付款单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '收款单') {
					var self = this;
					request.post('/api/ReceiptList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取收款单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packReceiptListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取收款单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '其它付款单') {
					var self = this;
					request.post('/api/OtherCostList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它付款单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packOtherCostListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它付款单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '采购订单') {
					var self = this;
					request.post('/api/PurchasePlanList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取采购订单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packPurchasePlanListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取采购订单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '采购单') {
					var self = this;
					request.post('/api/PurchaseList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取采购单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packPurchaseListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取采购单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '采购退货单') {
					var self = this;
					request.post('/api/ReturnList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取采购退货单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packPurchaseReturnListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取采购退货单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '其它收款单') {
					var self = this;
					request.post('/api/OtherReceiptList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它收款单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packOtherReceiptListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它收款单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '销售订单') {
					var self = this;
					request.post('/api/SalesPlanList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取销售订单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packSalesPlanListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取销售订单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '销售单') {
					var self = this;
					request.post('/api/SalesList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取销售单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packSalesListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取销售单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '销售退货单') {
					var self = this;
					request.post('/api/ReturnSalesList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取销售退货单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packSalesReturnListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取销售退货单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '零售单') {
					var self = this;
					request.post('/api/RetailList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取零售单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packRetailListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取零售单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '商品调拨单') {
					var self = this;
					request.post('/api/CommodityAllocationList/GetCompleteList', [parseInt(id)]).then(async function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取商品调拨单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							await self.packCommodityAllocationListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取商品调拨单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '成本调整单') {
					var self = this;
					request.post('/api/CommodityCostAdjustList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取成本调整单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packCommodityCostAdjustListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取成本调整单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '其它入库单') {
					var self = this;
					request.post('/api/EnterStoreList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它入库单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packEnterStoreListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它入库单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '其它出库单') {
					var self = this;
					request.post('/api/OutStoreList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它出库单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packOutStoreListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取其它出库单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '商品盘点单') {
					var self = this;
					request.post('/api/InventorySheet/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取商品盘点单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packInventorySheetPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取商品盘点单失败"
							});
						}
					}).catch(function(error) {})
				} else if (type == '组装拆卸单') {
					var self = this;
					request.post('/api/SplitList/GetCompleteList', [parseInt(id)]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取组装拆卸单失败"
							});
							return;
						}
						if (response.data.length > 0) {
							self.packSplitListPrintData(response.data[0]);
							self.initPage();
						} else {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取商品盘点单失败"
							});
						}
					}).catch(function(error) {})
				}
			},
			packSplitListPrintData(data){
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已审核'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				for (let i = 0; i < data.splitDetailList.length; i++) {
					data.splitDetailList[i].price = this.getCurrentRetailPrice(data.splitDetailList[i]);
				}
				for (let i = 0; i < data.assemblyDetailList.length; i++) {
					data.assemblyDetailList[i].price = this.getCurrentRetailPrice(data.assemblyDetailList[i]);
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'splitList',
					title: '组装拆卸单',
					attributes: ['baseFieldItem', 'splitDetailList', 'assemblyDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					assemblyDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						{
							name: 'price',
							displayName: '零售价'
						},
						{
							name: 'stock',
							displayName: '商品库存'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						}
					],
					splitDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						{
							name: 'price',
							displayName: '零售价'
						},
						{
							name: 'stock',
							displayName: '商品库存'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						}
					]
				};
			},
			packInventorySheetPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'inventorySheet',
					title: '商品盘点单',
					attributes: ['baseFieldItem', 'inventorySheetDetailLists'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userDisplayName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'lossAmount',
							displayName: '盈亏额'
						},
						{
							name: 'lossQuantity',
							displayName: '盈亏数量'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					inventorySheetDetailLists: [{
							name: 'commodityName',
							displayName: '商品名'
						}, {
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'accountBalance',
							displayName: '帐存数'
						},
						{
							name: 'actualNumbers',
							displayName: '实际数'
						},
						{
							name: 'deficiency',
							displayName: '盈亏数'
						},
						{
							name: 'lossAmount',
							displayName: '盈亏额'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					]
				};
			},
			packOutStoreListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				for (let i = 0; i < data.outStoreDetailList.length; i++) {
					data.outStoreDetailList[i].price = this.getCurrentRetailPrice(data.outStoreDetailList[i]);
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'outStoreList',
					title: '其它出库单',
					attributes: ['baseFieldItem', 'outStoreDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					outStoreDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						{
							name: 'price',
							displayName: '商品单价'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					]
				};
			},
			packEnterStoreListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				for (let i = 0; i < data.enterStoreDetailList.length; i++) {
					data.enterStoreDetailList[i].price = this.getCurrentIntoPrice(data.enterStoreDetailList[i]);
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'enterStoreList',
					title: '其它入库单',
					attributes: ['baseFieldItem', 'enterStoreDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					enterStoreDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						{
							name: 'price',
							displayName: '商品单价'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					]
				};
			},
			packCommodityCostAdjustListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'commodityCostAdjustList',
					title: '成本调整单',
					attributes: ['baseFieldItem', 'commodityCostAdjustDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					commodityCostAdjustDetailList: [{
							name: 'commodityName',
							displayName: '商品名'
						},
						{
							name: 'commodityFormat',
							displayName: '商品规格'
						},
						{
							name: 'lastIntoPrice',
							displayName: '调前采购价格'
						},
						{
							name: 'lastOutPrice',
							displayName: '调前销售价格'
						},
						{
							name: 'currentIntoPrice',
							displayName: '调后采购价格'
						},
						{
							name: 'currentOutPrice',
							displayName: '调后销售价格'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					]
				};
			},
			async packCommodityAllocationListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				data.warehousing = await this.getWarehousingName(data.warehousing);
				this.printData = {
					name: 'commodityAllocationList',
					title: '商品调拨单',
					attributes: ['baseFieldItem', 'commodityAllocationDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'warehousing',
							displayName: '入库仓库'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					commodityAllocationDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						// {
						// 	name: 'batchCode',
						// 	displayName: '商品批次'
						// },
						{
							name: 'outboundName',
							displayName: '出库仓库'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						},
						{
							name: 'quantity',
							displayName: '数量'
						}
					]
				};
			},
			packRetailListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'retailList',
					title: '零售单',
					attributes: ['baseFieldItem', 'retailDetailList',
						'extraCostInfos', 'logisticsInfos', 'footInfos'
					],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					retailDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					extraCostInfos: [{
							name: 'type',
							displayName: '费用类型'
						},
						{
							name: 'advancePayWay',
							displayName: '垫付方式'
						},
						{
							name: 'payAccount',
							displayName: '结算账户'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'createdate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					logisticsInfos: [{
							name: 'companyName',
							displayName: '物流公司'
						},
						{
							name: 'code',
							displayName: '物流单号'
						},
						{
							name: 'receiver',
							displayName: '收货人'
						},
						{
							name: 'freight',
							displayName: '运费'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			packSalesReturnListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.customerDiscount += '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'salesReturnList',
					title: '销售退货单',
					attributes: ['baseFieldItem', 'returnSalesDetailList',
						'extraCostInfos', 'logisticsInfos', 'footInfos'
					],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'customerName',
							displayName: '客户'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					returnSalesDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					extraCostInfos: [{
							name: 'type',
							displayName: '费用类型'
						},
						{
							name: 'advancePayWay',
							displayName: '垫付方式'
						},
						{
							name: 'payAccount',
							displayName: '结算账户'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'createdate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					logisticsInfos: [{
							name: 'companyName',
							displayName: '物流公司'
						},
						{
							name: 'code',
							displayName: '物流单号'
						},
						{
							name: 'receiver',
							displayName: '收货人'
						},
						{
							name: 'freight',
							displayName: '运费'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'customerDiscount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			packSalesListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.customerDiscount += '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'salesList',
					title: '销售单',
					attributes: ['baseFieldItem', 'salesDetailList', 'extraCostInfos',
						'logisticsInfos', 'footInfos'
					],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'customerName',
							displayName: '客户'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					salesDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					extraCostInfos: [{
							name: 'type',
							displayName: '费用类型'
						},
						{
							name: 'advancePayWay',
							displayName: '垫付方式'
						},
						{
							name: 'payAccount',
							displayName: '结算账户'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'createdate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					logisticsInfos: [{
							name: 'companyName',
							displayName: '物流公司'
						},
						{
							name: 'code',
							displayName: '物流单号'
						},
						{
							name: 'receiver',
							displayName: '收货人'
						},
						{
							name: 'freight',
							displayName: '运费'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'customerDiscount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			packSalesPlanListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.customerDiscount += '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'salesPlanList',
					title: '销售订单',
					attributes: ['baseFieldItem', 'salesPlanDetailList', 'footInfos'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'customerName',
							displayName: '客户'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					salesPlanDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					footInfos: [{
							name: 'customerDiscount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'deposit',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			packOtherReceiptListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.discount += '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'otherReceiptList',
					title: '其它收款单',
					attributes: ['baseFieldItem', 'otherReceiptDetailLists', 'footInfos'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'payer',
							displayName: '付款人'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					otherReceiptDetailLists: [{
							name: 'costName',
							displayName: '费用名称'
						},
						{
							name: 'costAmount',
							displayName: '费用金额'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					footInfos: [{
							name: 'discount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			packPurchaseReturnListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.supplierDiscount += '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'purchaseReturnList',
					title: '采购退货单',
					attributes: ['baseFieldItem', 'returnDetailList',
						'extraCostInfos', 'logisticsInfos', 'footInfos'
					],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'supplierName',
							displayName: '供应商'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					returnDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					extraCostInfos: [{
							name: 'type',
							displayName: '费用类型'
						},
						{
							name: 'advancePayWay',
							displayName: '垫付方式'
						},
						{
							name: 'payAccount',
							displayName: '结算账户'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'createdate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					logisticsInfos: [{
							name: 'companyName',
							displayName: '物流公司'
						},
						{
							name: 'code',
							displayName: '物流单号'
						},
						{
							name: 'receiver',
							displayName: '收货人'
						},
						{
							name: 'freight',
							displayName: '运费'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'supplierDiscount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						}
					]
				};
			},
			packPurchaseListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.supplierDiscount += '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'purchaseList',
					title: '采购单',
					attributes: ['baseFieldItem', 'purchaseDetailList',
						'extraCostInfos', 'logisticsInfos', 'footInfos'
					],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'supplierName',
							displayName: '供应商'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					purchaseDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					extraCostInfos: [{
							name: 'type',
							displayName: '费用类型'
						},
						{
							name: 'advancePayWay',
							displayName: '垫付方式'
						},
						{
							name: 'payAccount',
							displayName: '结算账户'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'createdate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					logisticsInfos: [{
							name: 'companyName',
							displayName: '物流公司'
						},
						{
							name: 'code',
							displayName: '物流单号'
						},
						{
							name: 'receiver',
							displayName: '收货人'
						},
						{
							name: 'freight',
							displayName: '运费'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'supplierDiscount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			packPurchasePlanListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.supplierDiscount += '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'purchasePlanList',
					title: '采购订单',
					attributes: ['baseFieldItem', 'purchasePlanDetailList','footInfos'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'supplierName',
							displayName: '供应商'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					purchasePlanDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					footInfos: [{
							name: 'supplierDiscount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'deposit',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			packOtherCostListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.discount = data.discount + '%';
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'otherCostList',
					title: '其它付款单',
					attributes: ['baseFieldItem', 'otherCostDetailLists', 'footInfos'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'payee',
							displayName: '收款人'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					otherCostDetailLists: [{
							name: 'costName',
							displayName: '费用名称'
						},
						{
							name: 'costAmount',
							displayName: '费用金额'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					footInfos: [{
							name: 'amount',
							displayName: '本单实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						}
					]
				};
			},
			packReceiptListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'receiptList',
					title: '收款单',
					attributes: ['baseFieldItem', 'receiptDetailLists', 'footInfos'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'payer',
							displayName: '付款人'
						},
						// {
						// 	name: 'discount',
						// 	displayName: '折扣'
						// },
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					receiptDetailLists: [{
							name: 'type',
							displayName: '单据类型'
						},
						{
							name: 'listCode',
							displayName: '单据编号'
						},
						{
							name: 'businessDate',
							displayName: '单据日期'
						},
						{
							name: 'listAmount',
							displayName: '单据金额'
						},
						{
							name: 'amountPaid',
							displayName: '已核销金额'
						},
						{
							name: 'amountUnpaid',
							displayName: '未核销金额'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'amount',
							displayName: '本单实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						}
					]
				};
			},
			packPaymentListPrintData(data) {
				switch (data.checkState) {
					case 1:
						data.checkState = '已创建'
						break;
					case 2:
						data.checkState = '已过账'
						break;
					case 3:
						data.checkState = '已完结'
						break;
				}
				data.businessDate = data.businessDate.replace(' 00:00:00', '');
				this.printData = {
					name: 'paymentList',
					title: '付款单',
					attributes: ['baseFieldItem', 'paymentDetailLists', 'footInfos'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'payee',
							displayName: '收款人'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						// {
						// 	name : 'discount',
						// 	displayName:'折扣'
						// },
						// {
						// 	name : 'originalPrice',
						// 	displayName:'本单金额'
						// },
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					paymentDetailLists: [{
							name: 'type',
							displayName: '单据类型'
						},
						{
							name: 'listCode',
							displayName: '单据编号'
						},
						{
							name: 'businessDate',
							displayName: '单据日期'
						},
						{
							name: 'listAmount',
							displayName: '单据金额'
						},
						{
							name: 'amountPaid',
							displayName: '已核销金额'
						},
						{
							name: 'amountUnpaid',
							displayName: '未核销金额'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'amount',
							displayName: '本单实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				};
			},
			initPage() {
				let data = localStorage.getItem('_printConfig' + this.printData.name)
				if (data) {
					this.printConfig = JSON.parse(data)
				} else {
					this.printConfig.receiptTitle = this.printData.title;
					for (let i = 0; i < this.printData.attributes.length; i++) {
						this.$set(this.printConfig, this.printData.attributes[i], []);
						for (let n = 0; n < 5; n++) {
							if (this.printData[this.printData.attributes[i]].length <= n) {
								break;
							}
							this.printConfig[this.printData.attributes[i]].push(this.printData[this.printData
								.attributes[
									i]][n].name);
						}
					}
				}
			},
			initPrintContext(data) {
				let printHtml = '';
				printHtml += '<div class="print-item">';
				printHtml += '<h3 style="text-align:center;">' + this.printConfig.receiptTitle + '</h3>';
				for (let j = 0; j < this.printData.attributes.length; j++) {
					if (!data[this.printData.attributes[j]]) {
						if (this.printConfig[this.printData.attributes[j]]) {
							printHtml += '<div class="print-item-part1">';
							for (let i = 0; i < this.printConfig[this.printData.attributes[j]].length; i++) {
								for (let n = 0; n < this.printData[this.printData.attributes[j]].length; n++) {
									if (this.printData[this.printData.attributes[j]][n].name == this.printConfig[this
											.printData.attributes[j]][i]) {
										printHtml += '<div class="print-item-part1-item">';
										printHtml += '<span style="font-weight: bold;">' + this.printData[this
												.printData.attributes[j]][n]
											.displayName + ':</span>';
										printHtml += '<span>' + data[this.printConfig[this.printData.attributes[j]][
											i
										]] + '</span>';
										printHtml += '</div>';
										break;
									}
								}
							}
							printHtml += '</div>';
							printHtml += '<div class="print-item-division"></div>';
						}
					} else {
						if (data[this.printData.attributes[j]].length <= 0) {
							continue
						}
						if (this.printConfig[this.printData.attributes[j]]) {
							printHtml += '<div class="print-item-part2">';
							for (let h = 0; h < this.printConfig[this.printData.attributes[j]].length; h++) {
								for (let i = 0; i < this.printData[this.printData.attributes[j]].length; i++) {
									if (this.printConfig[this.printData.attributes[j]][h] == this.printData[this
											.printData.attributes[j]][i].name) {
										printHtml += '<div class="print-item-part2-head">';
										printHtml += '<span>' + this.printData[this.printData.attributes[j]][i]
											.displayName + '</span>';
										printHtml += '</div>';
										break;
									}
								}
							}
							printHtml += '</div>';
							for (let n = 0; n < data[this.printData.attributes[j]].length; n++) {
								printHtml += '<div class="print-item-part2">';
								for (let i = 0; i < this.printConfig[this.printData.attributes[j]].length; i++) {
									let value = data[this.printData.attributes[j]][n][this.printConfig[
										this.printData.attributes[j]][i]].toString()
									printHtml += '<div class="print-item-part2-content">';
									printHtml += '<span>' + value + '</span>';
									printHtml += '</div>';
								}
								printHtml += '</div>';
							}
						}
						printHtml += '<div class="print-item-division"></div>';
					}
				}
				printHtml += '<div style="text-align:center;">不二账-进销存账单库存管理</div>';
				printHtml += '</div>';
				setTimeout(function() {
					document.getElementById('print-content').innerHTML = printHtml;
				}, 300)
			},
			print() {
				window.print();
			},
			getAttrDisplayName(param) {
				if (param.indexOf('base') > -1) {
					return '单据';
				} else if (param.indexOf('Cost') > -1) {
					return '费用信息';
				} else if (param.indexOf('Receipe') > -1) {
					return '费用信息';
				} else if (param.indexOf('Detail') > -1) {
					return '商品';
				} else if (param.indexOf('Package') > -1) {
					return '套餐';
				} else if (param.indexOf('extra') > -1) {
					return '额外费用';
				} else if (param.indexOf('logistics') > -1) {
					return '物流信息';
				}
			},
			getUnitData(detail,unitName) {
				if (detail.commodity.extraUnits) {
					let unit = detail.commodity.extraUnits.find(m => m.unit == unitName);
					if (unit) {
						return unit;
					}
				}
				return null;
			},
			getCurrentRetailPrice(data) {
				let items = data.format.split(',');
				if (items.length <= 0) {
					return 0;
				}
				let priceTypeGroup = data.commodity
					.commodityPriceTypeGroups.find(m => m.groupName == items[0]);
				if (!priceTypeGroup || priceTypeGroup.commodityPriceTypes.length <= 0) {
					return 0;
				}
				let priceType = priceTypeGroup.commodityPriceTypes.find(m => m.priceType == items[1]);
				if (!priceType) {
					return 0;
				}
				let unitData = this.getUnitData(data,data.unit);
				if(!unitData){
					return 0;
				}
				
				return formatNum(priceType.retailPrice / unitData.conversionRate);
			},
			getCurrentIntoPrice(data){
				let items = data.format.split(',');
				if(items.length <= 0){
					return 0;
				}
				let priceTypeGroup = data.commodity
					.commodityPriceTypeGroups.find(m=>m.groupName == items[0]);
				if (!priceTypeGroup || priceTypeGroup.commodityPriceTypes.length<=0) {
					return 0;
				}
				let priceType = priceTypeGroup.commodityPriceTypes.find(m=>m.priceType == items[1]);
				if(!priceType){
					return 0;
				}
				let unitData = this.getUnitData(data,data.unit);
				if(!unitData){
					return 0;
				}
				return formatNum(priceType.intoPrice / unitData.conversionRate);
			},
			async getWarehousingName(warehousing){
				let params = warehousing.split(',');
				let result = '';
				if(params.length < 1){
					return;
				}
				let depotTree = await this.getTransferDepot();
				depotTree.forEach(item=>{
					if(item.value == params[0]){
						result+=item.text;
						item.children.forEach(item2=>{
							if(item2.value == warehousing){
								result += ','+item2.text;
							}
						});
					}
				});
				return result;
			},
			async getTransferDepot() {
				let result1 = {};
				try {
					let result = await request.get('api/Depot/GetTransferDepot');
					if (result.state != 1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取调拨仓库数据失败"
						});
						return;
					}
					result1 = result.data;
				} catch (error) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取调拨仓库数据失败"
					});
				}
				return result1;
			},
		}
	}
</script>

<style>
	.layout {
		overflow: hidden;
	}

	.print-item {
		padding: 20px;
		margin-bottom: 20px;
		font-size: 14px;
		background-color: white;
	}

	.print-item-part1 {
		overflow: hidden;
		margin-top: 20px;
	}

	.print-item-part1-item {
		margin-bottom: 15px;
	}

	.print-item-part2 {
		display: flex;
		flex-wrap: nowrap;
	}

	.print-item-part2-head {
		font-weight: bold;
		width: 150px;
	}

	.print-item-part2-content {
		width: 150px;
		padding: 5px;
	}

	.print-item-division {
		width: 100%;
		border-bottom: 1px dotted;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	@media print {
		#app * {
			display: none;
		}

		.index-vue,
		.sec-right,
		.main-content,
		.view-c,
		.layout {
			display: block !important;
			margin: 0px !important;
			height: auto !important;
			min-height: auto !important;
			width: 100%;
		}

		#print-content {
			display: block !important;
			margin: 0px !important;
			padding: 0px;
			width: 100%;
		}

		.print-item {
			display: block !important;
			page-break-after: always;
			padding: 0px;
		}

		h3,
		.print-item-part1,
		.print-item-part1-item,
		.print-item-part2-head,
		.print-item-part2-content,
		.print-item-division {
			display: block !important;
		}

		.print-item-part2 {
			display: flex !important;
		}

		span {
			display: inline !important;
		}
	}
</style>